import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import './i18n';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { applyTheme, getStoredTheme } from './lib/theme';

// Re-apply the persisted theme once JS is live. The inline <script> in
// index.html already handled the very first paint to avoid a white flash.
applyTheme(getStoredTheme());

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
